import React, { useEffect, useState } from "react";
import { useTranslate } from "../../components/TranslationText";
import Loader from "../../components/Loader";
import NetaqInput from "../../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../../components/ActionButton";
import UploadFile from "../../components/SimpleFileUpload";
import { isLessThanOneYearOld } from "../../helper/isLessThanOneYearOld";
import { eFormButtonsContainer, eformInput, noDataCard, pageTitle } from "../../common/cssclasses";
import EahsForm from "../../components/EahsForm";
import SubmitServiceBtn from "../../components/servicesButtons/SubmitServiceBtn";
import CustomPopUp from "../../components/CustomPopUp";
import { addEditInternationalHorse, createShowEntry, getCountries, getHorseColors, getInternationalHorseById, searchInternationalHorse } from "./apis/CreateShowEntry";
import { isValidUrl } from "../../helper/validateURL";
import { isEmpty, validateInputs } from "../../helper/validaiteInputs";
import { formatDate } from "../../helper/formatDate";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";

export default function AddInternationalHorse() {

  const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
  const userProfile = JSON.parse(localStorage.getItem('eahsUserProfile') ?? '{}') ?? '';
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const showId = searchParams.has("showId")
    ? searchParams.get("showId")
    : "";
  const showNameAr = searchParams.has("showNameAr")
    ? searchParams.get("showNameAr")
    : "";
  const showNameEn = searchParams.has("showNameEn")
    ? searchParams.get("showNameEn")
    : "";
  const id = searchParams.has("horseId")
    ? searchParams.get("horseId")
    : "";
  const isEdit = searchParams.has("isEdit")
    ? searchParams.get("isEdit")
    : false;
  const [horseId, setHorseId] = useState(id);

  const [countriesData, setCountriesData] = useState([]);
  const { translate } = useTranslate();
  const [openPopUp, setOpenPopup] = useState(false);
  const certInit = {
    iDontHaveJawCertificate: false,
    iDontHaveVaccinationCertificate: false,
    jawCertificateFile: null,
    vaccinationCertificateFile: null
  }

  const [certificatesObj, setCertificateObj] = useState(certInit)

  const handleUpload = (e, setData) => {
    if (e.target.files && e.target.files.length > 0) {
      let checkFileSize = true;
      const fileListHook = [];

      for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
        if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
          checkFileSize = false;
          toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
        } else {
          // Check allowed file types
          const file = e.target.files[fileIndex];
          const allowedMimeTypes = ['image/', 'application/pdf'];

          if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
            toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
            continue; // Skip to the next file if type is not allowed
          }

          fileListHook.push({
            documentFile: URL.createObjectURL(e.target.files[fileIndex]),
            name: e.target.files[fileIndex].name,
            file: e.target.files[fileIndex],
          });
        }
      }
      setData(fileListHook);
    }
  };
  const handelHorseSelect = (horseId) => {
    getInternationalHorseById(horseId).then((res) => {
      setHorseId(horseId);
      setFormState({
        NameAr: res?.nameAr,
        NameEn: res?.nameEn,
        Gender: res?.gender,
        BirthDate: formatDate(res?.birthDate, true, true),
        HorseColorId: res?.horseColorId,
        Address: res?.address,
        HorseUELN: res?.horseUELN,
        InternationaMicroshipNo: res?.internationaMicroshipNo,
        OriginId: res?.originId,
        RegistrationNumber: res?.registrationNumber,
        IsOwner: res?.isOwner ?? false,
        DamNameEn: res?.damNameEn,
        DamNameAr: res?.damNameAr,
        SireNameAr: res?.sireNameAr,
        SireNameEn: res?.sireNameEn,
        CurrentCountryId: res?.currentCountryId,
        OwnerNameAr: res?.ownerNameAr,
        OwnerNameEn: res?.ownerNameEn,
        BreederNameEn: res?.breederNameEn,
        BreederNameAr: res?.breederNameAr,
      })
      if (res?.horseQualificationsList.length > 0) {
        setQualificationObj({
          Class: res?.horseQualificationsList[0]?.className,
          CountryId: res?.horseQualificationsList[0]?.countryId,
          ShowName: res?.horseQualificationsList[0]?.showName,
          Year: formatDate(res?.horseQualificationsList[0]?.year, true, true),
          Rank: res?.horseQualificationsList[0]?.classRank,
          websiteURL: res?.horseQualificationsList[0]?.website != "null" ? res?.horseQualificationsList[0]?.website : '' ?? '',
        })
      }
      if (res?.vaccinationCertificate?.fileUrl != null) {
        setVaccinationCertificate([{
          name: res?.vaccinationCertificate?.fileName,
          file: res?.vaccinationCertificate?.fileUrl,
          fileUrl: res?.vaccinationCertificate?.fileUrl,
          documentUrl: res?.vaccinationCertificate?.fileUrl,
        }])
      }
      if (res?.jawCertificateFile?.fileUrl != null) {
        setJawCertificate([{
          name: res?.jawCertificateFile?.fileName,
          file: res?.jawCertificateFile?.fileUrl,
          fileUrl: res?.jawCertificateFile?.fileUrl,
          documentUrl: res?.jawCertificateFile?.fileUrl,
        }])
      }
      if (res.horseDocumentsList.length > 0) {

        const passport = res.horseDocumentsList.find((item) => item.documentType == 'PassPort');
        if (!!passport?.id ?? false) {
          setHorsePassport([{ ...passport, name: 'passport', file: passport.documentUrl, fileUrl: passport.documentUrl }]);
        }
        const OwnerProof = res.horseDocumentsList.find((item) => item.documentType == 'OwnerProof');
        if (!!OwnerProof?.id ?? false) {
          setOwnerProf([{ ...OwnerProof, name: 'OwnerProof', file: OwnerProof.documentUrl, fileUrl: OwnerProof.documentUrl }]);
        }
        const Certifications = res.horseDocumentsList.find((item) => item.documentType == 'Certifications');
        if (!!Certifications?.id ?? false) {
          setQualificationCerificate([{ ...Certifications, name: 'Certifications', file: Certifications.documentUrl, fileUrl: Certifications.documentUrl }]);
        }
      }
    })
    setOpenPopup(false);
  };
  const genderList = [{
    label: translate("web.mare", "Mare"),
    text: translate("web.mare", "Mare"),
    value: 1,
  },
  {
    label: translate("web.stallion", "Stallion"),
    text: translate("web.stallion", "Stallion"),
    value: 2,
  },
  {
    label: translate("web.gelding", "Gelding"),
    text: translate("web.gelding", "Gelding"),
    value: 3,
  },];
  const [internationalHorsesList, setInternationalHorsesList] = useState([]);
  const [horseColors, setHorseColors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [horsePassport, setHorsePassport] = useState([]);
  const [ownerProf, setOwnerProf] = useState([]);
  const [vaccinationCertificate, setVaccinationCertificate] = useState([]);
  const [jawCertificate, setJawCertificate] = useState([]);
  const [qualificationCerificate, setQualificationCerificate] = useState([]);


  const uploadPassport = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setHorsePassport([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };
  const uploadOwnerProf = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setOwnerProf([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };
  const uploadQualificationCerificate = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setQualificationCerificate([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };



  const horseData = {
    NameAr: '',
    NameEn: '',
    Gender: '',
    BirthDate: '',
    HorseColorId: '',
    Address: '',
    HorseUELN: '',
    InternationaMicroshipNo: '',
    OriginId: '',
    RegistrationNumber: '',
    IsOwner: false,
    DamNameEn: '',
    DamNameAr: '',
    SireNameAr: '',
    SireNameEn: '',
    CurrentCountryId: '',
    OwnerNameAr: '',
    OwnerNameEn: '',
    BreederNameEn: '',
    BreederNameAr: '',
  }


  const [searchObj, setSearchObj] = useState({
    Name: '',
    CountryId: '',
    UelnNo: ''
  });
  const [formState, setFormState] = useState(horseData);

  const [qualificationObj, setQualificationObj] = useState({
    CountryId: '',
    ShowName: '',
    Year: '',
    Class: '',
    Rank: ''
  })

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    })
  };
  const handleQualificationChange = (e) => {
    setQualificationObj({
      ...qualificationObj,
      [e.target.name]: e.target.value
    })
  };
  const handleSearchChange = (e) => {
    setSearchObj({
      ...searchObj,
      [e.target.name]: e.target.value
    })
  };

  useEffect(() => {
    getCountries().then((res) => {
      if (res.length <= 0) {
        toast.error(translate('web.erroringettingcountries', 'Error In getting Countries'))
        return;
      } else {
        setCountriesData(res);
      }
    })
    getHorseColors().then((res) => {
      if (res.length <= 0) {
        toast.error(translate('web.erroringettingColors', 'Error In getting Colors'))
        return;
      } else {
        setHorseColors(res);
      }
    })
    if (!!horseId) {
      handelHorseSelect(horseId);
    }
  }, [])

  function search() {
    if (isEmpty(searchObj?.Name) || isEmpty(searchObj?.CountryId)) {
      return;
    }
    searchInternationalHorse(searchObj?.Name, searchObj?.CountryId, searchObj?.UelnNo).then((res) => {
      setInternationalHorsesList(res);
    })
  }

  function submit() {
    const theField = `${translate('web.theField', 'The Field')} `;
    const isrequired = ` ${translate('web.isRequired', 'Is Required')}`;
    if (isEmpty(formState.NameEn)) {
      toast.error(theField + translate('web.horseNameEn', 'Horse Name En') + isrequired);
      return;
    }
    if (isEmpty(formState.NameAr)) {
      toast.error(theField + translate('web.horseNameAr', 'Horse Name ArNameAr') + isrequired);
      return;
    }
    if (isEmpty(formState.OriginId)) {
      toast.error(theField + translate('web.origin', 'Origin') + isrequired);
      return;
    }
    if (isEmpty(formState.RegistrationNumber)) {
      toast.error(theField + translate('web.currentRegistrationNumber', 'Current Registration Number') + isrequired);
      return;
    }
    if (isEmpty(formState.HorseColorId)) {
      toast.error(theField + translate('web.color', 'Color') + isrequired);
      return;
    }
    if (isEmpty(formState.Gender.toString())) {
      toast.error(theField + translate('web.gender', 'gender') + isrequired);
      return;
    }
    if (isEmpty(formState.BirthDate)) {
      toast.error(theField + translate('web.Birthdate', 'BirthDate') + isrequired);
      return;
    }
    if (isEmpty(formState.HorseUELN)) {
      toast.error(theField + translate('web.HorseUELN', 'HorseUELN') + isrequired);
      return;
    }
    if (isEmpty(formState.InternationaMicroshipNo)) {
      toast.error(theField + translate('web.microchipNo', 'InternationaMicroshipNo') + isrequired);
      return;
    }
    if (!formState.IsOwner && isEmpty(formState.OwnerNameEn)) {
      toast.error(theField + translate('web.OwnerNameEn', 'OwnerNameEn') + isrequired);
      return;
    }
    if (!formState.IsOwner && isEmpty(formState.OwnerNameAr)) {
      toast.error(theField + translate('web.OwnerNameAr', 'OwnerNameAr') + isrequired);
      return;
    }
    if (isEmpty(formState.BreederNameEn)) {
      toast.error(theField + translate('web.BreederNameEn', 'BreederNameEn') + isrequired);
      return;
    }
    if (isEmpty(formState.BreederNameAr)) {
      toast.error(theField + translate('web.BreederNameAr', 'BreederNameAr') + isrequired);
      return;
    }
    if (isEmpty(formState.SireNameEn)) {
      toast.error(theField + translate('web.SireNameEn', 'SireNameEn') + isrequired);
      return;
    }
    if (isEmpty(formState.SireNameAr)) {
      toast.error(theField + translate('web.SireNameAr', 'SireNameAr') + isrequired);
      return;
    }
    if (isEmpty(formState.DamNameEn)) {
      toast.error(theField + translate('web.DamNameEn', 'DamNameEn') + isrequired);
      return;
    }
    if (isEmpty(formState.DamNameAr)) {
      toast.error(theField + translate('web.DamNameAr', 'DamNameAr') + isrequired);
      return;
    }
    if (isEmpty(formState.CurrentCountryId)) {
      toast.error(theField + translate('web.CurrentCountry', 'CurrentCountry') + isrequired);
      return;
    }
    if (isEmpty(formState.Address)) {
      toast.error(theField + translate('web.horseAddress', 'horseAddress') + isrequired);
      return;
    }

    if ((!qualificationObj?.noRequiredQualifications) ?? false) {
      if (isEmpty(qualificationObj.CountryId)) {
        toast.error(theField + translate('web.countryName', 'countryName') + isrequired);
        return;
      }
      if (isEmpty(qualificationObj.ShowName)) {
        toast.error(theField + translate('web.showName', 'showName') + isrequired);
        return;
      }
      if (isEmpty(qualificationObj.Year)) {
        toast.error(theField + translate('web.Year', 'Year') + isrequired);
        return;
      }
      if (isEmpty(qualificationObj.Class)) {
        toast.error(theField + translate('web.className', 'className') + isrequired);
        return;
      }
      if (isEmpty(qualificationObj.Rank)) {
        toast.error(theField + translate('web.Rank', 'Rank') + isrequired);
        return;
      }
      if (!!qualificationObj?.websiteURL ?? false) {
        if (!isValidUrl(qualificationObj?.websiteURL)) {
          toast.error(theField + translate('web.urlNotValid', 'websiteURL'));
          return;
        }
      }
    }
    if (horsePassport.length <= 0) {
      toast.error(theField + translate('web.horsePassport', 'Horse Passport') + isrequired);
      return;
    }
    if (ownerProf.length <= 0) {
      toast.error(theField + translate('web.ownerProf', 'Owner Prof') + isrequired);
      return;
    }
    if (qualificationCerificate.length <= 0) {
      toast.error(theField + translate('web.qualificationCerificate', 'Qualification Cerificate') + isrequired);
      return;
    }
    if (certificatesObj.iDontHaveJawCertificate == false) {
      if (jawCertificate.length <= 0) {
        toast.error(theField + `${translate('web.jawCertificate', 'jawCertificate')}` + isrequired);
        throw new Error("Jaw Certificate is required");
      }
    }
    if (certificatesObj.iDontHaveVaccinationCertificate == false) {
      if (vaccinationCertificate.length <= 0) {
        toast.error(theField + `${translate('web.vaccinationCertificate', 'vaccinationCertificate')}` + isrequired);
        throw new Error("Vaccination Certificate is required");
      }
    }

    const formData = new FormData();
    for (const [key, value] of Object.entries(formState)) {
      formData.append(key, value);
    }
    if ((!qualificationObj?.noRequiredQualifications) ?? false) {
      formData.append(`HorseQualificationsList[0].CountryId`, qualificationObj.CountryId);
      formData.append(`HorseQualificationsList[0].ShowName`, qualificationObj.ShowName);
      formData.append(`HorseQualificationsList[0].Year`, new Date(qualificationObj.Year).toISOString());
      formData.append(`HorseQualificationsList[0].ClassName`, qualificationObj.Class);
      formData.append(`HorseQualificationsList[0].ClassRank`, qualificationObj.Rank);
      formData.append(`HorseQualificationsList[0].Website`, qualificationObj?.websiteURL);
    }

    if (jawCertificate.length > 0) {
      formData.append(`JawCertificateFile`, jawCertificate?.file ?? null);
    }
    if (vaccinationCertificate.length > 0) {
      formData.append(`VaccinationCertificateFile`, vaccinationCertificate?.file ?? null);
    }

    formData.append(`HorseDocumentsList[0].DocumentType`, 'PassPort');
    if (!!horsePassport[0]?.fileUrl) {
      formData.append(`HorseDocumentsList[0].DocumentUrl`, horsePassport[0].fileUrl);
    } else {
      formData.append(`HorseDocumentsList[0].DocumentFile`, horsePassport[0].file);
    }
    formData.append(`HorseDocumentsList[1].DocumentType`, 'Certifications');
    if (!!qualificationCerificate[0]?.fileUrl) {
      formData.append(`HorseDocumentsList[1].DocumentUrl`, qualificationCerificate[0].fileUrl);
    } else {
      formData.append(`HorseDocumentsList[1].DocumentFile`, qualificationCerificate[0].file);
    }
    formData.append(`HorseDocumentsList[2].DocumentType`, 'OwnerProof');
    if (!!ownerProf[0]?.fileUrl) {
      formData.append(`HorseDocumentsList[2].DocumentUrl`, ownerProf[0]?.fileUrl);
    } else {
      formData.append(`HorseDocumentsList[2].DocumentFile`, ownerProf[0].file);
    }
    if (certificatesObj.iDontHaveJawCertificate == false) {
      formData.append(`JawCertificateFile`, 'jawCertificate');
      if (!!jawCertificate[0]?.fileUrl) {
        formData.append(`JawCertificateFile`, jawCertificate[0]?.fileUrl);
      } else {
        formData.append(`JawCertificateFile`, jawCertificate[0].file);
      }
    }
    if (certificatesObj.iDontHaveVaccinationCertificate == false) {
      formData.append(`VaccinationCertificateFile`, 'vaccinationCertificate');
      if (!!vaccinationCertificate[0]?.fileUrl) {
        formData.append(`VaccinationCertificateFile`, vaccinationCertificate[0]?.fileUrl);
      } else {
        formData.append(`VaccinationCertificateFile`, vaccinationCertificate[0].file);
      }
    }
    formData.append(`CreatedBy`, userProfile?.id);
    if (!!horseId) {
      formData.append(`Id`, horseId);
    }
    formData.append(`ShowId`, showId);
    addEditInternationalHorse(formData).then((res) => {
      if (!!res) {
        toast.success(translate('web.addedToShow', 'Added To Show'))
        navigate(`/showParticipate?showId=${showId}`)
        // setTimeout(() => {
        //   createShowEntry('Draft', [res], showId).then((res) => {
        //     if (res) {

        //     } else {
        //       toast.success(translate('web.errorInAddingHorse', 'Error In Adding Horse'))
        //     }
        //   })
        // }, 1000);

      }
    })
  }


  if (isLoading) {
    return (
      <Loader />
    )
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        closeOnClick
        theme="colored"
        autoClose={5000}
      />
      <div className="row rtl">
        <h2 className={pageTitle}>
          {translate("web.addInternationalHorse", "Add International Horse")} - {currentLanguage === "en" ? showNameEn : showNameAr}
        </h2>

        {isEdit != 'true' &&
          <>
            <EahsForm isNoMargin title={translate("web.checkExistingHorse", "Check Existing Horse")} className='mb-main'>
              <div className={eformInput}>
                <NetaqInput
                  label={translate("web.horseNameEn", "Horse Name (En)")}
                  name={"Name"}
                  placeholder={translate("web.horseNameEn", "Horse Name (En)")}
                  type={"horseName"}
                  onChange={handleSearchChange}
                  value={searchObj?.Name}
                  required={true}
                />
              </div>
              <div className={eformInput}>
                <NetaqInput
                  label={translate("web.origin", "Origin")}
                  type='select'
                  listSelect={countriesData}
                  value={countriesData.find((item) => item.value == searchObj?.CountryId)}
                  onChange={(selectedItem) => {
                    setSearchObj((prev) => ({ ...prev, CountryId: selectedItem?.value }))
                  }}
                  placeholder={translate("web.chooseOrigin", "Choose Origin")}
                  name={"origin"}
                  required
                />
              </div>
              <div className={eformInput}>
                <NetaqInput
                  label={translate("web.ueln", "UELN")}
                  name={"UelnNo"}
                  placeholder={translate("web.ueln", "UELN")}
                  type={"text"}
                  onChange={handleSearchChange}
                  value={searchObj?.UelnNo}
                />
                <div className="horseCardDescription fw-bold mt-2 mb-0">
                  {translate(
                    "web.checkSearchInterHorse",
                    "*You can search by (horse name english and origin) or (ueln)*"
                  )}
                </div>
              </div>
            </EahsForm>
            <div className={eFormButtonsContainer + ' mb-main'}>
              <SubmitServiceBtn
                onClick={() => setOpenPopup(true)}
                disabled={isEmpty(searchObj.Name) || isEmpty(searchObj.CountryId)}
                text={<>
                  <i class="fa-solid fa-magnifying-glass-plus"></i>
                  {translate(
                    "web.checkExistingHorse",
                    "Check Existing Horse"
                  )}
                </>}
              />
              <CustomPopUp
                open={openPopUp}
                onOpen={() => search()}
                title={translate("web.resultSearch", "Result Search")}
                content={<>
                  <table className="table table-striped table-bordered rtl horseResultTable mb-0">
                    <thead className="theadHorseSelect">
                      <tr>
                        <th className="text-center">
                          {translate("web.name", "Name")}
                        </th>
                        <th className="text-center">
                          {translate("web.birthDate", "Birth Date")}
                        </th>
                        <th className="text-center">
                          {translate("web.registerNumber", "Register Number")}
                        </th>
                        <th className="text-center">
                          {translate("web.origin", "Origin")}
                        </th>
                        <th className="text-center">
                          {translate("web.color", "Color")}
                        </th>
                        <th className="text-center">
                          {translate("web.owner", "owner")}
                        </th>
                        <th className="text-center">
                          {translate("web.breeder", "Breeder")}
                        </th>
                        <th className="text-center">
                          {translate("web.gender", "Gender")}
                        </th>
                        <th className="text-center">
                          {translate("web.action", "Action")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {!!internationalHorsesList.length > 0 ? (
                        internationalHorsesList.map((item, i) => (
                          <tr key={i}>
                            <td>{item.name}</td>
                            <td>{item?.birthDate}</td>
                            <td>{item.registerNumber}</td>
                            <td>{item.origin}</td>
                            <td>{item.color}</td>
                            <td>{item.owner}</td>
                            <td>{item.breeder}</td>
                            <td>{item.gender}</td>
                            <td>
                              <ActionButton
                                type={"submit"}
                                label={translate("web.select", "Select")}
                                text={translate("web.select", "Select")}
                                width={"100%"}
                                onClick={() =>
                                  handelHorseSelect(item.id)
                                }
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={9}>
                            <div className={noDataCard}>
                              {translate('web.nodatafound', 'No Data Found')}
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>}
              />

            </div>
          </>}


        {
          //Horse Details
        }

        <EahsForm isNoMargin title={translate("web.horseDetails", "Horse Details")} className='mb-main' >
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.horseNameEn", "Horse Name (En)")}
              name={"NameEn"}
              placeholder={translate("web.horseNameEn", "Horse Name (En)")}
              type={"horseName"}
              isEnOnly={true}
              onChange={handleChange}
              value={formState?.NameEn}
              required={true}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.horseNameAr", "Horse Name (Ar)")}
              name={"NameAr"}
              placeholder={translate("web.horseNameAr", "Horse Name (Ar)")}
              type={"text"}
              onChange={handleChange}
              value={formState?.NameAr}
              required={true}
            // 
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              required
              label={translate("web.origin", "Origin")}
              type='select'
              listSelect={countriesData}
              value={countriesData.find((item) => item.value == formState?.OriginId)}
              onChange={(selectedItem) => {
                setFormState((prev) => ({ ...prev, OriginId: selectedItem?.value }))
              }}
              placeholder={translate("web.chooseOrigin", "Choose Origin")}
              name={"OriginId"}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.currentRegNo", "Current Reg No")}
              name={"RegistrationNumber"}
              placeholder={translate("web.currentRegNo", "Current Reg No")}
              type={"number"}
              onChange={handleChange}
              value={formState?.RegistrationNumber}
              required={true}
            // 
            />
          </div>
          <div className={eformInput}>

            <NetaqInput
              type="select"
              required
              label={translate("web.color", "Color")}
              listSelect={horseColors}
              value={horseColors.find((item) => item.value == formState?.HorseColorId)}
              onChange={(selectedItem) => {
                setFormState((prev) => ({ ...prev, HorseColorId: selectedItem?.value }))
              }}
              placeholder={translate("web.color", "Color")}
              name={"HorseColorId"}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              type="select"
              label={translate("web.gender", "Gender")}
              required
              listSelect={genderList}
              value={genderList.find((item) => item.value == formState?.Gender)}
              onChange={(selectedItem) => setFormState((prev) => ({ ...prev, Gender: selectedItem?.value }))}
              placeholder={translate("web.gender", "Gender")}
              name={"gender"}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              type={'normalDate'}
              label={translate("web.birthDate", "Birth Date")}
              name={`BirthDate`}
              value={formState?.BirthDate}
              onChange={handleChange}
              required={true}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.HorseUELN", "HorseUELN")}
              name={"HorseUELN"}
              placeholder={translate("web.HorseUELN", "HorseUELN")}
              type={"text"}
              onChange={handleChange}
              value={formState?.HorseUELN}
              required={true}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.microchipNo", "InternationaMicroshipNo")}
              name={"InternationaMicroshipNo"}
              placeholder={translate("web.microchipNo", "InternationaMicroshipNo")}
              type={"text"}
              onChange={handleChange}
              value={formState?.InternationaMicroshipNo}
              required={true}
            />
          </div>
          <div className={eformInput} />
          <div className="mb-form-group">
            <NetaqInput
              name={"IsOwner"}
              type={"checkbox"}
              label={translate("web.ownedByMe", "Owned By Me")}
              checked={formState?.IsOwner}
              onChange={(e) => {
                if (e.target.checked) {
                  setFormState((prev) => ({ ...prev, IsOwner: e.target.checked, OwnerNameEn: userProfile.fullName, OwnerNameAr: userProfile.fullNameAr }))
                } else {
                  setFormState((prev) => ({ ...prev, IsOwner: e.target.checked }))
                }
              }}

            />
          </div>
          <div className={eformInput}>

            <NetaqInput
              label={translate("web.ownerNameEn", "Owner Name in (En)")}
              name={"OwnerNameEn"}
              placeholder={translate("web.ownerNameEn", "Owner Name in (En)")}
              type={"horseName"}
              onChange={handleChange}
              isEnOnly
              isSupportAllCharacters
              value={formState?.OwnerNameEn}
              disabled={formState?.IsOwner}
              required={true}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.ownerNameAr", "Owner Name in (Ar)")}
              name={"OwnerNameAr"}
              placeholder={translate("web.ownerNameAr", "Owner Name in (Ar)")}
              type={"text"}
              onChange={handleChange}
              value={formState?.OwnerNameAr}
              disabled={formState?.IsOwner}
              required={true}
            />
          </div>

          <div className={eformInput}>
            <NetaqInput
              label={translate("web.breederNameEn", "Breeder Name (En)")}
              name={"BreederNameEn"}
              placeholder={translate(
                "web.breederNameEn",
                "Breeder Name (En)"
              )}
              type={"horseName"}
              onChange={handleChange}
              setFormState
              isEnOnly
              isSupportAllCharacters
              value={formState?.BreederNameEn}
              required={true}

            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.breederNameAr", "Breeder Name (Ar)")}
              name={"BreederNameAr"}
              placeholder={translate(
                "web.breederNameAr",
                "Breeder Name (Ar)"
              )}
              type={"text"}
              onChange={handleChange}
              setFormState
              value={formState?.BreederNameAr}
              required={true}

            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.sireNameEn", "Sire Name (En)")}
              name={"SireNameEn"}
              placeholder={translate("web.sireNameEn", "Sire Name (En)")}
              type={"horseName"}
              onChange={handleChange}
              value={formState?.SireNameEn}
              required={true}
              isEnOnly

            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.sireNameAr", "Sire Name (Ar)")}
              name={"SireNameAr"}
              placeholder={translate("web.sireNameAr", "Sire Name (Ar)")}
              type={"text"}
              onChange={handleChange}
              value={formState?.SireNameAr}
              required={true}

            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.damNameEn", "Dam Name (En)")}
              name={"DamNameEn"}
              placeholder={translate("web.damNameEn", "Dam Name (En)")}
              type={"horseName"}
              isEnOnly
              onChange={handleChange}
              value={formState?.DamNameEn}
              required={true}

            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.damNameAr", "Dam Name (Ar)")}
              name={"DamNameAr"}
              placeholder={translate("web.damNameAr", "Dam Name (Ar)")}
              type={"text"}
              onChange={handleChange}
              value={formState?.DamNameAr}
              required={true}

            />
          </div>

          <div className={eformInput}>
            <NetaqInput
              type="select"
              label={translate("web.horseCountry", "Horse Country")}
              required
              listSelect={countriesData}
              value={countriesData.find((item) => item.value == formState?.CurrentCountryId)}
              onChange={(selectedItem) => setFormState((prev) => ({ ...prev, CurrentCountryId: selectedItem?.value }))}
              placeholder={translate("web.horseCountry", "Horse Country")}
              name={"CurrentCountryId"}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.horseAddress", "Horse Address")}
              name={"Address"}
              placeholder={translate("web.horseAddress", "Horse Address")}
              type={"text"}
              onChange={handleChange}
              value={formState?.Address}
              required={true}

            />
          </div>
        </EahsForm>


        <EahsForm isNoMargin title={translate("web.horsequalifications", "Horse Qualifications")} className='mb-main' >
          {isLessThanOneYearOld(new Date(formState?.BirthDate)) && (
            <div
              className="col-md-12 col-sm-12 mb-form-group"
            >
              <NetaqInput
                name={"noRequiredQualifications"}
                type={"checkbox"}
                label={translate(
                  "web.noRequiredQualifications",
                  "There is no required qualifications"
                )}
                onChange={(e) => {
                  setQualificationObj((prev) => ({ ...prev, noRequiredQualifications: e.target.checked }))
                }
                }

              />
            </div>
          )}
          <div className={eformInput}>
            <NetaqInput
              type='select'
              label={translate("web.countryName", "Country Name")}
              required
              value={countriesData.find((item) => item.value == qualificationObj?.CountryId)}
              onChange={(selectedItem) => setQualificationObj((prev) => ({ ...prev, CountryId: selectedItem?.value }))}
              placeholder={translate("web.countryName", "Country Name")}
              name={"countryQual"}
              listSelect={countriesData}
              disabled={qualificationObj?.noRequiredQualifications}

            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.showName", "Show Name")}
              name={"ShowName"}
              placeholder={translate("web.showName", "Show Name")}
              type={"text"}
              onChange={handleQualificationChange}
              value={qualificationObj?.ShowName}
              required={true}
              disabled={qualificationObj?.noRequiredQualifications}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              name={"Year"}
              type={"normalDate"}
              label={translate("web.year", "Year")}
              onChange={handleQualificationChange}
              value={qualificationObj?.Year}
              minDate={formState?.BirthDate}
              required={true}
              disabled={qualificationObj?.noRequiredQualifications}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate("web.className", "Class Name")}
              name={"Class"}
              placeholder={translate("web.className", "Class Name")}
              type={"text"}
              onChange={handleQualificationChange}
              value={qualificationObj?.Class}
              required={true}
              disabled={qualificationObj?.noRequiredQualifications}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              type='number'
              name="Rank"
              label={translate("web.classRank", "Class Rank")}
              required
              min="1"
              step="1"
              onChange={handleQualificationChange}
              value={qualificationObj?.Rank}
              disabled={qualificationObj?.noRequiredQualifications}
            />
          </div>
          <div className={eformInput}>
            <NetaqInput
              label={translate(
                "web.referenceWebsiteURL",
                "Reference Website URL"
              )}
              name={"websiteURL"}
              placeholder={translate("web.websiteURL", "Website URL")}
              type={"text"}
              onChange={handleQualificationChange}
              value={qualificationObj?.websiteURL}
              disabled={qualificationObj?.noRequiredQualifications}
            />
            {qualificationObj?.websiteURL && (!isValidUrl(qualificationObj?.websiteURL)) &&
              <span className={`text-danger`}>
                {translate("web.urlNotValid", "URL not valid")}
              </span>
            }
          </div>
        </EahsForm>

        {
          //Horse Documents
        }
        <EahsForm isNoMargin title={translate("web.uploadHorseDocuments", "Upload Horse Documents")} className='mb-main' >
          <div className={eformInput}>
            <label class="capatalize_text">
              {translate("web.passport", "Passport")}
              <i style={{ color: "red" }}>*</i>
            </label>
            <UploadFile
              text={"Upload"}
              initialFiles={
                horsePassport
              }
              isServer={horsePassport.length > 0 &&
                !!horsePassport[0]?.documentUrl
              }
              onChange={uploadPassport}
              iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
              accept={"image/*,application/pdf"}
            />
            <div className="mt-2 horseCardDescription">
              * {translate(
                "web.uploadHorsePassportType",
                "Upload horse passport pages which contain all the horse details in one or multi files (pdf, jpg, or jpeg)"
              )}
            </div>
          </div>
          <div className={eformInput}>
            <label class="capatalize_text">
              {translate("web.ownershipProof", "Ownership Proof")}
              <i style={{ color: "red", margin: "auto 2px" }}>*</i>
            </label>
            <UploadFile
              text={"Upload"}
              initialFiles={ownerProf}
              isServer={ownerProf.length > 0 &&
                !!ownerProf[0]?.documentUrl
              }
              onChange={uploadOwnerProf}
              iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
              accept={"image/*,application/pdf"}
            />
            <div className="mt-2 horseCardDescription">
              * {translate(
                "web.uploadHorseOwnershipType",
                "Upload the horse ownership or authority proof documents in one or multi files (pdf, jpg, or jpeg)"
              )}
            </div>
          </div>
          <div className={eformInput}>
            <label class="capatalize_text">
              {translate(
                "web.qualificationCertification",
                "Qualification Certificate"
              )}
              <i style={{ color: "red", margin: "auto 2px" }}>*</i>
            </label>
            <UploadFile
              text={"Upload"}
              initialFiles={qualificationCerificate}
              isServer={qualificationCerificate.length > 0 &&
                !!qualificationCerificate[0]?.documentUrl
              }
              onChange={uploadQualificationCerificate}
              iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
              accept={"image/*,application/pdf"}
            />
            <div className="mt-2 horseCardDescription">
              * {translate(
                "web.uploadHorseQualificationsCertificatesType",
                "Upload the horse qualifications certificates if-any in one or multi files (pdf, jpg, or jpeg)"
              )}
            </div>
          </div>
          <div className={eformInput} >
            <label class="capatalize_text">
              {translate("web.vaccinationCertificate", "vaccinationCertificate")}
            </label>
            <UploadFile
              text={"Upload"}
              initialFiles={vaccinationCertificate}

              isServer={vaccinationCertificate?.length > 0 &&
                !!vaccinationCertificate[0]?.documentUrl}
              onChange={(e) => handleUpload(e, setVaccinationCertificate)}
              iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
              accept="image/*,application/pdf"
              isMulti={false}
              disabled={!!certificatesObj?.iDontHaveVaccinationCertificate} />
            <NetaqInput
              type='checkbox'
              label={translate("web.uploadCertificateLater", "Select Date") + " (" + translate("web.vaccinationCertificate", "vaccinationCertificate") + ")"}
              value={certificatesObj?.iDontHaveVaccinationCertificate}
              checked={certificatesObj?.iDontHaveVaccinationCertificate}
              onChange={(e) => setCertificateObj({
                ...certificatesObj,
                iDontHaveVaccinationCertificate: e.target.checked
              })}
              placeholder={translate("web.uploadCertificateLater", "Select Date")}
              name={"vaccinationCertificate"}
              disabled={!!vaccinationCertificate?.length > 0} />
          </div>
          <div className={eformInput} >
            <label class="capatalize_text">
              {translate("web.jawCertificate", "vaccinationCertificate")}
            </label>
            <UploadFile
              text={"Upload"}
              initialFiles={jawCertificate}
              isServer={jawCertificate?.length > 0 &&
                !!jawCertificate[0]?.documentUrl}
              onChange={(e) => handleUpload(e, setJawCertificate)}
              iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
              accept="image/*,application/pdf"
              isMulti={false}
              disabled={!!certificatesObj?.iDontHaveJawCertificate} />
            <NetaqInput
              type='checkbox'
              label={translate("web.uploadCertificateLater", "Select Date") + " (" + translate("web.jawCertificate", "vaccinationCertificate") + ")"}
              value={certificatesObj?.iDontHaveJawCertificate}
              checked={certificatesObj?.iDontHaveJawCertificate}
              onChange={(e) => setCertificateObj({
                ...certificatesObj,
                iDontHaveJawCertificate: e.target.checked
              })}
              placeholder={translate("web.uploadCertificateLater", "Select Date")}
              name={"jawCertificate"}
              disabled={!!jawCertificate?.length > 0} />
          </div>
        </EahsForm>

        {
          //complete buttons
        }
        <div className={eFormButtonsContainer}>
          <SubmitServiceBtn
            onClick={() => submit()}
          // onClick={handelFormSubmit}

          />
        </div>
      </div>
    </>
  );
}
